<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <app-zaver-icon class="icon-user-img" [size]="80" name="mailCircle" ></app-zaver-icon>
      <h1 class="heading">Prüfen Sie Ihr E-Mail-Postfach</h1>
      <p class="info-text">
        Bitte überprüfen Sie Ihre E-Mail und<br />
        übermitteln Sie den 4-stelligen Code hier.
      </p>

      <div class="email-wrapper">{{ email }}</div>

      <div class="token-input-wrapper">
        <zaver-token-input
          (valueChange)="onOtpChange($event)"
          [showError]="showError"
          [isMobile]="isMobile"
          [IOS]="IOS"
          [maxLength]="otpLength"
        ></zaver-token-input>
      </div>

      <div class="display-error" *ngIf="showError">
        <img src="assets/icon/icon_error.svg" alt="" class="info-icon" />
        <p>Der Verifizierungscode ist falsch oder&nbsp;bereitsabgelaufen</p>
      </div>

      <app-general-error
        *ngIf="!showError && noResponseError"
        class="general-error"
      ></app-general-error>

      <div class="resend-code" [ngClass]="showError ? 'error' : ''">
        <zaver-button-link
          [text]="'E-Mail erneut senden'"
          (click)="resendCode()"
          [disabled]="navigationInProgress"
          [interactive]="true"
        ></zaver-button-link>
      </div>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="button-container">
            <zaver-primary-button
              text="Weiter"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
